'use client';

import React__default, { useContext, useMemo } from 'react';
import { CountText, CheckBoxLabelWrapper, CheckBoxLabel, JobCount, DropdownItemWrapper, SingleCheckItem } from './DropdownItem.css.js';
import CheckBox from '../../../../../CheckBox/index.js';
import GlyphIcons from '../../../../../GlyphIcons/index.js';
import Button from '../../../../../Button/index.js';
import { CascaderContext } from '../../../../context/reducer.js';
import { ACTIONS } from '../../../../context/actions.js';
import { VIEWINDEX, KEYCODE, QUERY_SELECTOR_FIRST_RIGHT_ELEMENT } from '../../../../constants.js';
import HighlightText from '../HighlightText/index.js';

var DropdownItem = function (params) {
    var _a = useContext(CascaderContext), props = _a.props, state = _a.state, t = _a.t, dispatch = _a.dispatch;
    var label = params.label, id = params.id, parentId = params.parentId, _b = params.isHaveChildren, isHaveChildren = _b === void 0 ? false : _b, checkState = params.checkState, isSelected = params.isSelected, _c = params.isSelectedValue, isSelectedValue = _c === void 0 ? false : _c, _d = params.jobCount, jobCount = _d === void 0 ? 0 : _d, leftColumnRef = params.leftColumnRef, _e = params.selectedCount, selectedCount = _e === void 0 ? 0 : _e, _f = params.isHighlightText, isHighlightText = _f === void 0 ? false : _f;
    var options = props.options, isMobile = props.isMobile, langCode = props.langCode, selectOptions = props.selectOptions, onConfirm = props.onConfirm;
    var isHover = state.isHover, hoverParentId = state.hoverParentId, keyword = state.keyword, viewIndex = state.viewIndex;
    var selectedParentId = state.parentId;
    var onClickViewChild = function () {
        var _a, _b;
        if (!isHaveChildren) {
            return;
        }
        // Allow to de-select by click on that value again
        var selectedId = id;
        if (keyword === '' && selectedParentId === id) {
            selectedId = -1;
        }
        if (isMobile) {
            dispatch({
                type: ACTIONS.MOBILE_SET_SELECT_PARENT_ID,
                payload: {
                    parentId: selectedId,
                    leftScrollPosition: (_b = (_a = leftColumnRef === null || leftColumnRef === void 0 ? void 0 : leftColumnRef.current) === null || _a === void 0 ? void 0 : _a.scrollTop) !== null && _b !== void 0 ? _b : 0
                }
            });
        }
        else {
            dispatch({
                type: ACTIONS.SET_SELECT_PARENT_ID,
                payload: selectedId
            });
        }
    };
    var onCheckChange = function () {
        if (isHaveChildren) {
            if (selectOptions.isSingleSelect) {
                onClickViewChild();
                return;
            }
            dispatch({
                type: ACTIONS.SET_TEMPORARY_VALUE,
                payload: {
                    parentId: id,
                    children: options.children
                }
            });
            if (selectOptions.hiddenFooter) {
                dispatch({
                    type: ACTIONS.APPLY_CALLBACK,
                    payload: onConfirm
                });
                dispatch({
                    type: ACTIONS.SYNC_TEMPORARY_TO_VALUE
                });
            }
        }
        else {
            dispatch({
                type: selectOptions.isSingleSelect ? ACTIONS.SET_SINGLE_TEMPORARY_VALUE : ACTIONS.SET_TEMPORARY_VALUE,
                payload: {
                    parentId: parentId,
                    childrenId: id,
                    children: options.children
                }
            });
            if (selectOptions.hiddenFooter) {
                dispatch({
                    type: ACTIONS.APPLY_CALLBACK,
                    payload: onConfirm
                });
                dispatch({
                    type: ACTIONS.SYNC_TEMPORARY_TO_VALUE
                });
            }
            if (selectOptions.isSingleSelect) {
                // onCofirm on single select is simple because it only return 1 value
                onConfirm &&
                    onConfirm([
                        {
                            parentId: parentId,
                            childrenIds: [id]
                        }
                    ]);
                dispatch({
                    type: ACTIONS.ON_CONFIRM
                });
            }
        }
    };
    var onMouseOver = function () {
        if (isMobile) {
            return;
        }
        if (!isHaveChildren) {
            return;
        }
        if (isHover && hoverParentId === id) {
            return;
        }
        dispatch({
            type: ACTIONS.SET_HOVER_ID,
            payload: id
        });
    };
    var onFocus = function () {
        if (isMobile || !isHaveChildren) {
            return;
        }
        dispatch({
            type: ACTIONS.ON_DROPDOWN_ITEM_FOCUS,
            payload: id
        });
    };
    var onKeyDown = function (e) {
        switch (e.code) {
            case KEYCODE.SPACE: {
                e.preventDefault();
                onCheckChange();
                break;
            }
            case KEYCODE.ARROW_RIGHT: {
                e.preventDefault();
                if (!isHaveChildren) {
                    break;
                }
                onClickViewChild();
                // Auto focus on first child
                setTimeout(function () {
                    var _a;
                    if (!(leftColumnRef === null || leftColumnRef === void 0 ? void 0 : leftColumnRef.current) || !leftColumnRef.current.parentElement) {
                        return;
                    }
                    var element = (_a = leftColumnRef.current.parentElement) === null || _a === void 0 ? void 0 : _a.querySelector(QUERY_SELECTOR_FIRST_RIGHT_ELEMENT);
                    element === null || element === void 0 ? void 0 : element.focus();
                }, 50);
                break;
            }
        }
    };
    return useMemo(function () {
        var selectCountText = React__default.createElement(React__default.Fragment, null);
        if (selectedCount === -1) {
            selectCountText = React__default.createElement(CountText, null, t('All'));
        }
        else if (selectedCount > 0) {
            selectCountText = React__default.createElement(CountText, null, selectedCount);
        }
        var formattedLabel = React__default.createElement(React__default.Fragment, null, label);
        if (isHighlightText && keyword !== '') {
            formattedLabel = React__default.createElement(HighlightText, { keyword: keyword }, label);
        }
        // Render label
        var checkBoxLabel = (React__default.createElement(CheckBoxLabelWrapper, null,
            React__default.createElement(CheckBoxLabel, { isHaveJobCount: jobCount > 0 }, formattedLabel),
            jobCount > 0 && React__default.createElement(JobCount, null,
                "(",
                jobCount,
                ")"),
            (selectedCount === -1 || selectedCount > 0) && !selectOptions.isSingleSelect && React__default.createElement(React__default.Fragment, null, selectCountText)));
        var tabIndex = 0;
        if (parentId !== -1 && parentId !== id) {
            tabIndex = -1;
        }
        if (hoverParentId !== parentId) {
            tabIndex = -1;
        }
        // Current cursor on left column OR
        // For children (It always allowed to select)
        if (viewIndex === VIEWINDEX.LEFT || (viewIndex === VIEWINDEX.RIGHT && !isHaveChildren)) {
            tabIndex = 0;
        }
        return (React__default.createElement(DropdownItemWrapper, { "data-id": id, "data-parent-id": parentId, isSelected: isSelected, isSelectedValue: selectOptions.isSingleSelect ? isSelectedValue : false, isHaveChildren: isHaveChildren, onMouseOver: onMouseOver, tabIndex: tabIndex, onFocus: onFocus, onKeyDown: onKeyDown },
            selectOptions.isSingleSelect ? (React__default.createElement(SingleCheckItem, { isChecked: checkState !== 'none', onClick: onCheckChange }, checkBoxLabel)) : (React__default.createElement(CheckBox, { state: checkState, label: checkBoxLabel, onCheckChange: onCheckChange, tabIndex: -1 })),
            isHaveChildren && (React__default.createElement(Button, { isIcon: true, isRounded: true, tabIndex: -1, outline: 'none', type: 'default', size: 'sm', onClick: onClickViewChild },
                React__default.createElement(GlyphIcons.NextArrowIcon, null)))));
    }, [
        checkState,
        id,
        hoverParentId,
        isHaveChildren,
        isSelected,
        label,
        parentId,
        jobCount,
        viewIndex,
        selectedCount,
        langCode,
        keyword,
        isHighlightText
    ]);
};

export { DropdownItem as default };
//# sourceMappingURL=index.js.map
